<template>
  <b-row class="match-height">
    <b-col>
      <b-card no-body>
        <!-- <b-card-header>
          <b-card-title class="mb-50">
            แสดงสรุปขายสินค้าขายดีประจำเดือน
          </b-card-title>
        </b-card-header>

        <b-card-body>
          <vue-apex-charts
            type="bar"
            height="400"
            :options="apexChatData.columnChart.chartOptions"
            :series="apexChatData.columnChart.series"
          />
        </b-card-body> -->
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BCardTitle, BCardBody, BCardHeader, BDropdown, BDropdownItem, BCardSubTitle,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import VueApexCharts from 'vue-apexcharts'
import chartjsData from './chartjsData'
import apexChatData from './apexChartData'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BCardBody,
    BCardHeader,
    BDropdown,
    BDropdownItem,
    BCardSubTitle,
    flatPickr,
    VueApexCharts,
  },
  data() {
    return {
      data: {},
      apexChatData,
      chartjsData,
      rangePicker: ['2019-05-01', '2019-05-10'],
    }
  },
  created() {
    // data
    this.$http.get('/ecommerce/data')
      .then(response => {
        this.data = response.data
      })
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
